import { Typography, CircularProgress, Grid, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Wrapper } from "components/wrapper";
import { DetailCard, DetailField, DetailSectionTitle } from "components/detailPage";
import { DocumentList } from "components/documentList";
import { useConselhoDetailsState } from "./context/conselho-details-context";
import { useConselhoDetailsController } from "./context/conselho-details-controller";

const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString('pt-BR') : '-';

export function ConselhoDetailsPage() {
  const { conselhoDetails, loading, error } = useConselhoDetailsState();
  const { loadConselhoDetails, clearConselhoDetails } = useConselhoDetailsController();
  let { id } = useParams<{ id: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (id) {
      loadConselhoDetails(parseInt(id));
    }

    return () => {
      clearConselhoDetails();
    };
  }, [id, loadConselhoDetails, clearConselhoDetails]);

  if (loading) {
    return (
      <Wrapper>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <CircularProgress />
        </div>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <Typography color="error" variant="h6">{error}</Typography>
      </Wrapper>
    );
  }

  if (!conselhoDetails) {
    return (
      <Wrapper>
        <Typography variant="h6">Conselho não encontrado.</Typography>
      </Wrapper>
    );
  }

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Conselhos", href: "/conselhos" },
          { label: conselhoDetails.nomeConselho },
        ]}
      />
      <PageTitle>{conselhoDetails.nomeConselho}</PageTitle>
      <Wrapper>
        <DetailCard>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Chip label={conselhoDetails.areaName} color="primary" />
            </Grid>

            {conselhoDetails.textoNormaCriacao && (
              <Grid item xs={12}>
                <DetailField label="Norma de Criação" value={conselhoDetails.textoNormaCriacao} />
              </Grid>
            )}

            <Grid item xs={12}>
              <DetailSectionTitle>Membros</DetailSectionTitle>
              {conselhoDetails.membros && conselhoDetails.membros.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell>Entidade Representada</TableCell>
                        <TableCell>Cargo</TableCell>
                        <TableCell>Mandato</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {conselhoDetails.membros.map((membro) => (
                        <TableRow key={membro.id}>
                          <TableCell>{membro.nomeMembro}</TableCell>
                          <TableCell>{membro.textoEntidadeRepresentada}</TableCell>
                          <TableCell>{membro.textoCargo}</TableCell>
                          <TableCell>{formatDate(membro.dtaInicioMandato)} a {membro.dtaFimMandato ? formatDate(membro.dtaFimMandato) : 'atual'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body2" color="textSecondary">Nenhum membro cadastrado.</Typography>
              )}
            </Grid>

            <Grid item xs={12}>
              <DetailSectionTitle>Atas</DetailSectionTitle>
              <DocumentList documents={conselhoDetails.atas} />
            </Grid>
          </Grid>
        </DetailCard>
      </Wrapper>
    </>
  );
}
